/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 *
 * Design System — FailureActionPicker sub-primitive
 */
import cx from 'classnames';
import React from 'react';

import { RadioGroup } from '../../components/Radio';
import type { RadioOption } from '../../components/Radio';
import type { FailureActionOption } from '../../types';

import './FailureActionPicker.less';

export interface FailureActionPickerProps {
  /** Selected option value */
  value: string;
  /** All available options */
  options: FailureActionOption[];
  /** Fires with the new value when selection changes */
  onChange: (value: string) => void;
  /** Disables the whole radio group */
  disabled?: boolean;
  /** Optional heading above the radio group */
  label?: React.ReactNode;
  /** Extra class merged onto the outer wrapper */
  className?: string;
}

const FailureActionPicker: React.FC<FailureActionPickerProps> = ({
  value,
  options,
  onChange,
  disabled,
  label,
  className,
}) => {
  const groupName = React.useMemo(() => `ds-failure-action-picker-${Math.random().toString(36).slice(2, 9)}`, []);
  const radioOptions: RadioOption[] = options;

  return (
    <div className={cx('ds-failure-action-picker', className)}>
      {label !== undefined && label !== null && <div className="ds-failure-action-picker__label">{label}</div>}
      <RadioGroup
        name={groupName}
        direction="vertical"
        value={value}
        disabled={disabled}
        onChange={onChange}
        options={radioOptions}
      />
    </div>
  );
};

FailureActionPicker.displayName = 'FailureActionPicker';

export { FailureActionPicker };
export default FailureActionPicker;
